import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import React from 'react';
import { Attachments, MarkupElement } from 'src/functions/formatElement.htmlAst';
import { TableOfContent } from 'src/functions/getTableOfContentDictionary';
import ArticleBody from 'molecules/ArticleBody/ArticleBody';
import TableOfContents from 'molecules/TableOfContents/TableOfContents';

interface ArticleWithTableOfContentsProps {
  title?: string;
  slug: string;
  articleTitle: string;
  pathPrefix: string;
  contentHtmlAst: MarkupElement[];
  attachments: Attachments;
  tableOfContents: TableOfContent[];
  articleBodyId?: string;
  articleBodyClassName?: string;
  extraElement?: React.ReactNode;
}

const ArticleWithTableOfContents = ({
  title = 'Table of Contents',
  slug,
  articleTitle,
  pathPrefix,
  contentHtmlAst,
  attachments,
  tableOfContents,
  articleBodyId = '',
  articleBodyClassName = '',
  extraElement,
}: ArticleWithTableOfContentsProps): JSX.Element => {
  return (
    <Grid
      gap='spacing-4xl'
      gapSm='spacing-2xl'
    >
      <Stack
        direction='row'
        columns={12}
        gap='spacing-6xl'
        justify='center'
      >
        <TableOfContents
          title={title}
          slug={slug}
          articleTitle={articleTitle}
          pathPrefix={pathPrefix}
          tableOfContents={tableOfContents}
          hideOn='lg'
          extraElement={extraElement}
        />
        <ArticleBody
          id={articleBodyId}
          contentHtmlAst={contentHtmlAst}
          attachments={attachments}
          className={articleBodyClassName}
        />
      </Stack>
    </Grid>
  );
};

export default ArticleWithTableOfContents;
